module.exports = __webpack_public_path__ + "static/media/maestro.fc2fa6eb.jpg";